import {
  boolean, date, mixed, number,
  object, string,
} from "yup";

import { MARKET_TYPES, MAX_PAYMENT_DAY_VALUE, MIN_PAYMENT_DAY_VALUE } from "./Billings.constants";

const billingFormValidationSchema = object().shape({
  name: string().required(),
  sector: object<TOption>().required(),
  sectorCode: object<TOption>().required(),
  paymentDayOffset: number().required()
    .min(MIN_PAYMENT_DAY_VALUE)
    .max(MAX_PAYMENT_DAY_VALUE),
  startTime: date().required(),
  endTime: date().required(),
  accordPower: number().required(),
  setPower: number().required(),
  voltage: string().required(),
  term: string().required(),
  marketType: string().required(),
  isGreen: boolean(),
  // Optional validations
  margin: mixed().when("marketType", (value: string[], schema) => {
    if (value[0] !== MARKET_TYPES.FREE_MARKET) {
      return schema.notRequired();
    }
    return number().required();
  }),
  isFixedMargin: mixed().when("marketType", (value: string[], schema) => {
    if (value[0] !== MARKET_TYPES.FREE_MARKET) {
      return schema.notRequired();
    }
    return boolean().required();
  }),
});

export const createBillingFormValidation = billingFormValidationSchema.shape({
  installationReference: object<TOption>().required(),
});

export const updateBillingFormValidation = billingFormValidationSchema
  .shape({
    meterSerialNumber: string(),
    etsoCode: string(),
  })
  .test("is-optional", "", (props) => {
    const { meterSerialNumber, etsoCode } = props;
    return !(meterSerialNumber === "" && etsoCode === "");
  });
